// CUSTOM (Empat): "Added" success state for Add-to-cart buttons using snippets/mf-atc-button-content.liquid
// (product cards and cart upsell cards). The loading state needs no JS - the stock <product-form> already
// sets aria-busy on the button during the request, and assets/theme.css styles that. This only listens
// for the theme's own variant:add event (fired by product-form on success) and flags that form's
// buttons for a moment. Loaded once from layout/theme.liquid. See CUSTOM-CHANGES.md.
const SUCCESS_DURATION = 2000;

if (!window.mfCardAtcStateLoaded) {
  window.mfCardAtcStateLoaded = true;

  document.addEventListener('variant:add', (event) => {
    const buttons = event.target.closest?.('product-form')?.querySelectorAll('.mf-card-atc') ?? [];

    buttons.forEach((button) => {
      clearTimeout(button.mfResetTimer);
      button.setAttribute('data-mf-state', 'added');
      button.mfResetTimer = setTimeout(() => button.removeAttribute('data-mf-state'), SUCCESS_DURATION);
    });
  });
}
